import Genre from "./Genre";

export default Genre;
